export default __webpack_public_path__ + "static/media/blood5.2cbd74b1.png";